export enum MemoSubToggles {
  Memo = 'Memo',
  ActualsTermsheet = 'Actuals Termsheet',
  HypotheticalsTermsheet = 'Hypotheticals Termsheet',
  AggregateNotional = 'Aggregate Notional',
  Effectiveness = 'Effectiveness',
}
